module.exports = __webpack_public_path__ + "static/media/meditation.f50dc316.svg";